(function () {
  'use strict';

  var enhancedAttribute = 'data-mochi-product-details-enhanced';

  function cleanClone(source) {
    var clone = source.cloneNode(true);
    clone.querySelectorAll('style, script, noscript').forEach(function (node) {
      node.remove();
    });
    clone.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });
    return clone;
  }

  function normalizedText(node) {
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // 2026-10-14 ゆうさく「これなんでセットの中身載ってないの」「じゃあ他のセットもそうなってるんじゃないの」：
  // セットの中身の見出しを広く読む。頭の絵文字・記号（📋 📦 🎀 など）、「(5 Items)」「5 items」、Includes・In this set・What's inside なども。
  var SET_HEAD = "[^A-Za-z0-9]*(?:Set includes|Set contents|Included items|Contents|Includes|In this set|What's inside|What's included|This set includes)(?:\\s*\\([^)]*\\)|\\s+\\d+\\s+(?:items?|pieces?|pcs))?";
  var SET_HEAD_INLINE = new RegExp('^' + SET_HEAD + '\\s*:', 'i');
  var SET_HEAD_INLINE_STRIP = new RegExp('^' + SET_HEAD + '\\s*:\\s*', 'i');
  var SET_HEAD_ONLY = new RegExp('^' + SET_HEAD + '\\s*:?$', 'i');
  var SET_HEAD_PLAIN_INCLUDES = /^[^A-Za-z0-9]*Includes\b/i;

  function removeRedundantDetails(container) {
    container.querySelectorAll('p').forEach(function (paragraph) {
      var text = normalizedText(paragraph);
      if (!text) {
        paragraph.remove();
        return;
      }
      if (/^📋\s*Details:?$/i.test(text)) {
        paragraph.remove();
        return;
      }
      if (/^(?:🇯🇵\s*)?Official Japanese merchandise shipped directly from Japan\b/i.test(text)) {
        paragraph.remove();
        return;
      }
      if (/CyStore lifecycle:|limited-per-customer purchase limit|pre-order deadline on CyStore/i.test(text)) {
        paragraph.remove();
      }
    });
  }

  function linesFromElement(element) {
    var clone = element.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(document.createTextNode('\n'));
    });
    return (clone.textContent || '').split(/\n+/).map(function (line) {
      return line.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
  }

  function convertFactParagraphs(container) {
    container.querySelectorAll('p').forEach(function (paragraph) {
      var lines = linesFromElement(paragraph);
      if (lines.length < 2) return;
      var facts = [];
      var unmatched = [];
      lines.forEach(function (line) {
        var match = line.match(/^([^:]{1,34}):\s*(.+)$/);
        if (match) {
          facts.push({ label: match[1].replace(/^[^A-Za-z0-9]+/, '').trim(), value: match[2].trim() });
        } else if (!/^📋\s*Details:?$/i.test(line)) {
          unmatched.push(line);
        }
      });
      if (facts.length < 2 || unmatched.length > 0) return;
      var list = document.createElement('dl');
      list.className = 'mochi-product-facts';
      facts.forEach(function (fact) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var detail = document.createElement('dd');
        term.textContent = fact.label;
        detail.textContent = fact.value;
        row.append(term, detail);
        list.append(row);
      });
      paragraph.replaceWith(list);
    });
  }

  function createDetailIcon(kind) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var paths = {
      official: ['M4 7l8-4 8 4v10l-8 4-8-4V7z', 'M4 7l8 4 8-4M12 11v10'],
      size: ['M4 17L17 4l3 3L7 20H4v-3z', 'M13 8l3 3M10 11l2 2M7 14l3 3'],
      material: ['M12 3l2.1 4.3L19 8l-3.5 3.4.8 4.8-4.3-2.3-4.3 2.3.8-4.8L5 8l4.9-.7L12 3z'],
      condition: ['M6 8h12l1 12H5L6 8z', 'M9 8V6a3 3 0 016 0v2'],
      preorder: ['M12 21a9 9 0 100-18 9 9 0 000 18z', 'M12 7v5l3 2'],
      series: ['M4 6h10l6 6-8 8-8-8V6z', 'M9 10h.01']
    };
    (paths[kind] || paths.series).forEach(function (definition) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', definition);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.append(path);
    });
    return svg;
  }

  function createDetailRow(kind, label, value) {
    var row = document.createElement('div');
    row.className = 'mochi-product-detail-row';
    var icon = document.createElement('span');
    icon.className = 'mochi-product-detail-icon';
    icon.append(createDetailIcon(kind));
    var text = document.createElement('span');
    text.className = 'mochi-product-detail-text';
    if (label) {
      var strong = document.createElement('strong');
      strong.textContent = label + ': ';
      text.append(strong);
    }
    text.append(document.createTextNode(value));
    row.append(icon, text);
    return row;
  }

  function splitNumberedItems(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return [];
    var markers = [];
    var markerPattern = /(?:^|\s)(\d{1,2})\.\s+/g;
    var match;
    while ((match = markerPattern.exec(text)) !== null) {
      markers.push({
        number: Number(match[1]),
        start: match.index + match[0].length,
        markerStart: match.index + (match[0].charAt(0) === ' ' ? 1 : 0)
      });
    }
    if (markers.length < 2 || markers[0].number !== 1) return [];
    for (var index = 1; index < markers.length; index += 1) {
      if (markers[index].number !== markers[index - 1].number + 1) return [];
    }
    return markers.map(function (marker, index) {
      var end = index + 1 < markers.length ? markers[index + 1].markerStart : text.length;
      return text.slice(marker.start, end).trim();
    }).filter(Boolean);
  }

  function createSetContentsRow(items) {
    var row = document.createElement('div');
    row.className = 'mochi-product-detail-row mochi-product-detail-row--set';
    var icon = document.createElement('span');
    icon.className = 'mochi-product-detail-icon';
    icon.append(createDetailIcon('series'));
    var content = document.createElement('div');
    content.className = 'mochi-product-detail-text mochi-product-detail-set';
    var strong = document.createElement('strong');
    strong.textContent = 'Set contents:';
    var list = document.createElement('ol');
    list.className = 'mochi-product-set-list';
    items.forEach(function (item) {
      var listItem = document.createElement('li');
      listItem.textContent = String(item || '').replace(/^\d{1,2}[.)]\s+/, '').trim();
      list.append(listItem);
    });
    content.append(strong, list);
    row.append(icon, content);
    return row;
  }

  function cleanFactValue(label, value) {
    var cleaned = value.replace(/^Approximately\s+/i, '').trim();
    if (/^Material$/i.test(label)) {
      cleaned = cleaned.replace(/Body\s*[—–-]\s*/i, '').replace(/;\s*Carabiner\s*[—–-]\s*/i, ', ');
    }
    return cleaned;
  }

  function collectLooseFacts(container) {
    var loose = [];
    Array.from(container.querySelectorAll('p, li')).forEach(function (paragraph) {
      linesFromElement(paragraph).forEach(function (line) {
        var match = line.match(/^([^:]{1,40}):\s*(.*)$/);
        if (!match) return;
        var label = match[1].replace(/^[^A-Za-z0-9]+/, '').trim();
        var value = match[2].trim();
        if (!value) return;
        if (/^(Maker|Brand|Manufacturer|Product|Series|Material|Condition|Color|Release Date)$/i.test(label)
          || isDimensionLabel(label)) {
          loose.push({ label: label, value: value });
        }
      });
    });
    return loose;
  }

  function extractSetContents(container) {
    var paragraphs = Array.from(container.querySelectorAll('p, h2, h3, h4'));
    var inline = paragraphs.find(function (paragraph) {
      var lines = linesFromElement(paragraph);
      return lines.length > 0 && SET_HEAD_INLINE.test(lines[0]);
    });
    if (inline) {
      var inlineLines = linesFromElement(inline);
      var firstLine = String(inlineLines.shift() || '').replace(SET_HEAD_INLINE_STRIP, '').trim();
      if (firstLine) inlineLines.unshift(firstLine);
      var inlineItems = inlineLines.map(function (line) {
        return line.replace(/^[•·\-*]\s*/, '').trim();
      }).filter(Boolean);
      if (inlineItems.length === 1) {
        var numberedInline = splitNumberedItems(inlineItems[0]);
        if (numberedInline.length) return numberedInline;
      }
      if (inlineItems.length) return inlineItems;
    }
    var headingIndex = paragraphs.findIndex(function (paragraph) {
      return SET_HEAD_ONLY.test(normalizedText(paragraph));
    });
    if (headingIndex < 0) return [];
    var next = paragraphs[headingIndex].nextElementSibling;
    if (!next) return [];
    var lines = next.matches('ul, ol') ? Array.from(next.querySelectorAll('li')).map(normalizedText) : linesFromElement(next);
    var cleaned = lines.map(function (line) {
      return line.replace(/^[•·\-*]\s*/, '').trim();
    }).filter(Boolean);
    // 「Includes」は1つだけの商品（例：Includes → Figure）にも使うので、2つ以上ある時だけセットの中身として出す
    if (SET_HEAD_PLAIN_INCLUDES.test(normalizedText(paragraphs[headingIndex])) && cleaned.length < 2) return [];
    if (cleaned.length === 1) {
      var numbered = splitNumberedItems(cleaned[0]);
      if (numbered.length) return numbered;
    }
    return cleaned;
  }

  // 2026-10-19 ゆうさく「これじゃ新品なのか中古なのかとか全然わからんよ」：見出しと段落の文字がくっつく（「ConditionBrand new.」）と
  // Brand New を見つけられなかった。要素ごとに空白を入れて読み、「Condition」の見出しのすぐ後の段落もそのまま状態として使う。
  function spacedText(container) {
    var parts = Array.from(container.querySelectorAll('h1, h2, h3, h4, h5, p, li, dt, dd, td, th')).map(normalizedText).filter(Boolean);
    return parts.length ? parts.join(' ') : normalizedText(container);
  }

  function conditionUnderHeading(container) {
    var heading = Array.from(container.querySelectorAll('h2, h3, h4, h5, strong')).find(function (node) {
      return /^Condition:?$/i.test(normalizedText(node));
    });
    if (!heading) return '';
    var next = heading.tagName === 'STRONG' ? null : heading.nextElementSibling;
    var value = next ? normalizedText(next) : '';
    return value && value.length <= 80 ? value.replace(/\.$/, '') : '';
  }

  function inferCondition(container, factRows) {
    var existing = factRows.find(function (fact) { return /^Condition$/i.test(fact.label); });
    if (existing) return '';
    var underHeading = conditionUnderHeading(container);
    if (/^brand new$/i.test(underHeading)) return 'Brand New';
    var text = spacedText(container);
    if (/\bBrand New\b|\bnever worn\b/i.test(text)) return 'Brand New';
    if (/\bLike New\b/i.test(text) && /\bNo Box\b/i.test(text)) return 'Like New (No Box)';
    if (/\bLike New\b|\bexcellent condition\b/i.test(text)) return 'Like New';
    if (/\bPre-owned\b|\bUsed condition\b/i.test(text)) return 'Pre-owned';
    return underHeading || '';
  }

  // 2026-10-19：予約の言葉を消した商品は「Release date in Japan: …」だけになる。その行を「Release date」として出す
  // （前は「Pre-order」の段落だけを出していたので、発売日がどこにも出なくなった。ゆうさく「発売日情報どこにも書いてなくない？」）。
  function releaseDateText(container, factRows) {
    if (factRows.some(function (fact) { return /^Release\s*date/i.test(fact.label); })) return '';
    var match = spacedText(container).match(/Release date in Japan:\s*([^.]{3,40}?\d{4})/i);
    return match ? match[1].trim() : '';
  }

  function isDimensionLabel(label) {
    return /^(?:Size(?:\s+[A-Z0-9/+-]+|\s*\([^)]*\))?|Dimensions?|Head circumference|Brim length|Height|Width|Length|Diameter)$/i.test(label);
  }

  function officialText(container, factRows, productTitle, manufacturer, fulfillmentType) {
    if (manufacturer) return 'Official ' + manufacturer + ' merchandise';
    var maker = factRows.find(function (fact) { return /^(Maker|Brand|Manufacturer)$/i.test(fact.label); });
    if (maker) return 'Official ' + maker.value + ' merchandise';
    if (fulfillmentType === 'original_set') return 'Curated set of authentic Japanese merchandise from multiple brands';
    var text = normalizedText(container);
    var merchandise = text.match(/official\s+([^.!?]{2,60}?)\s+merchandise\b/i);
    if (merchandise) return 'Official ' + merchandise[1].trim() + ' merchandise';
    if (/Official JRA\b/i.test(text) || /Official JRA\b/i.test(productTitle || '')) return 'Official JRA merchandise';
    if (/Thoroughbred Collection/i.test(text) || /Thoroughbred Collection/i.test(productTitle || '')) return 'Official SK JAPAN merchandise';
    return 'Authentic Japanese merchandise';
  }

  function addDimensionRow(list, factRows) {
    var dimensions = factRows.filter(function (fact) {
      return isDimensionLabel(fact.label);
    });
    if (!dimensions.length) return;
    var value = dimensions.map(function (fact) {
      if (/^(Size|Dimensions?)(?:\s*\([^)]*\))?$/i.test(fact.label)) return cleanFactValue('Size', fact.value);
      return fact.label + ' ' + fact.value;
    }).join(' · ');
    list.append(createDetailRow('size', 'Size', value));
  }

  function buildStructuredDetails(container, productTitle, manufacturer, fulfillmentType) {
    var factRows = Array.from(container.querySelectorAll('.mochi-product-facts > div')).map(function (row) {
      return {
        label: normalizedText(row.querySelector('dt')),
        value: normalizedText(row.querySelector('dd'))
      };
    }).filter(function (fact) { return fact.label && fact.value; });
    if (!factRows.length) factRows = collectLooseFacts(container);

    var setContents = extractSetContents(container);
    var inferredCondition = inferCondition(container, factRows);
    var releaseDate = releaseDateText(container, factRows);
    var preorder = Array.from(container.querySelectorAll('p')).find(function (paragraph) {
      return /Pre-order/i.test(normalizedText(paragraph));
    });
    if (!factRows.length && !setContents.length && !inferredCondition && !preorder && !releaseDate) return null;

    var list = document.createElement('div');
    list.className = 'mochi-product-detail-list';
    list.append(createDetailRow('official', '', officialText(container, factRows, productTitle, manufacturer, fulfillmentType)));

    addDimensionRow(list, factRows);

    factRows.forEach(function (fact) {
      if (/^(Maker|Brand|Manufacturer)$/i.test(fact.label)
        || isDimensionLabel(fact.label)) return;
      var kind = /^Material$/i.test(fact.label) ? 'material'
          : /^Condition$/i.test(fact.label) ? 'condition'
            : 'series';
      list.append(createDetailRow(kind, fact.label, cleanFactValue(fact.label, fact.value)));
    });

    if (inferredCondition) list.append(createDetailRow('condition', 'Condition', inferredCondition));
    if (releaseDate && !preorder) list.append(createDetailRow('series', 'Release date', releaseDate));
    if (setContents.length) list.append(createSetContentsRow(setContents));
    if (preorder) {
      var preorderText = normalizedText(preorder).replace(/^[^A-Za-z0-9]*Pre-order\s*[—–:-]?\s*/i, '').trim();
      list.append(createDetailRow('preorder', 'Pre-order', preorderText || 'Release date shown above'));
    }

    var fragment = document.createDocumentFragment();
    fragment.append(list);
    Array.from(container.querySelectorAll('p')).filter(function (paragraph) {
      var text = normalizedText(paragraph);
      return /^⚠️?\s*/.test(text) || /^※/.test(text) || /factory imperfections|please note|sizing tends to run smaller/i.test(text);
    }).forEach(function (paragraph) {
      var note = paragraph.cloneNode(true);
      note.className = 'mochi-product-detail-note';
      fragment.append(note);
    });
    return fragment;
  }

  function buildGenericDetails(container, productTitle, includeOfficial, manufacturer, fulfillmentType) {
    var list = document.createElement('div');
    list.className = 'mochi-product-detail-list mochi-product-detail-list--generic';
    if (includeOfficial) list.append(createDetailRow('official', '', officialText(container, [], productTitle, manufacturer, fulfillmentType)));

    var currentLabel = 'Details';
    var notes = [];
    Array.from(container.querySelectorAll('h2, h3, h4, p, ul, ol')).forEach(function (node) {
      var text = normalizedText(node);
      if (!text) return;
      if (/^H[234]$/.test(node.tagName)) {
        currentLabel = /^(Description|Product Details)$/i.test(text) ? 'Details' : text.replace(/:$/, '');
        return;
      }
      if (SET_HEAD_ONLY.test(text)) {
        currentLabel = 'Set contents';
        return;
      }
      if (/^(?:🇯🇵\s*)?Official Japanese merchandise shipped directly from Japan\b/i.test(text)) return;
      if (/^⚠️?\s*/.test(text) || /^※/.test(text) || /factory imperfections|please note|sizing tends to run smaller/i.test(text)) {
        var note = document.createElement('p');
        note.className = 'mochi-product-detail-note';
        note.textContent = text;
        notes.push(note);
        return;
      }
      if (node.matches('ul, ol')) {
        var listItems = Array.from(node.querySelectorAll('li')).map(normalizedText).filter(Boolean);
        if (currentLabel === 'Set contents' && listItems.length) {
          list.append(createSetContentsRow(listItems));
          currentLabel = 'Details';
          return;
        }
        text = listItems.join(' · ');
      }
      if (currentLabel === 'Set contents') {
        var numberedItems = splitNumberedItems(text);
        if (numberedItems.length) {
          list.append(createSetContentsRow(numberedItems));
          currentLabel = 'Details';
          return;
        }
      }
      list.append(createDetailRow('series', currentLabel, text));
      currentLabel = 'Details';
    });

    if (!list.querySelector('.mochi-product-detail-row') || (includeOfficial && list.querySelectorAll('.mochi-product-detail-row').length === 1)) {
      var fallbackText = normalizedText(container);
      if (fallbackText) list.append(createDetailRow('series', 'Details', fallbackText));
    }

    var fragment = document.createDocumentFragment();
    fragment.append(list);
    notes.forEach(function (note) { fragment.append(note); });
    return fragment;
  }

  function createPanel(id, label, active) {
    var panel = document.createElement('div');
    panel.id = id;
    panel.className = 'mochi-product-tab-panel';
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-label', label);
    if (!active) panel.hidden = true;
    return panel;
  }

  function createTab(id, panelId, label, active) {
    var tab = document.createElement('button');
    tab.id = id;
    tab.type = 'button';
    tab.className = 'mochi-product-tab';
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', panelId);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.tabIndex = active ? 0 : -1;
    tab.textContent = label;
    return tab;
  }

  function activateTab(tabs, panels, selectedIndex, moveFocus) {
    tabs.forEach(function (tab, index) {
      var selected = index === selectedIndex;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      panels[index].hidden = !selected;
      if (selected && moveFocus) tab.focus();
    });
  }

  function addTabBehavior(tabList, tabs, panels) {
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tabs, panels, index, false);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        activateTab(tabs, panels, nextIndex, true);
      });
    });
    tabList.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        var index = tabs.indexOf(document.activeElement);
        if (index >= 0) {
          event.preventDefault();
          activateTab(tabs, panels, index, false);
        }
      }
    });
  }

  function createGalleryArrow(direction, label) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mochi-gallery-nav-button mochi-gallery-nav-button--' + direction;
    button.setAttribute('aria-label', label);
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M15 18l-6-6 6-6');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    button.append(svg);
    return button;
  }

  function galleryThumbnailButtons(gallery) {
    return Array.from(gallery.querySelectorAll('.thumbnail-slider .thumbnail'));
  }

  function moveGallery(gallery, direction) {
    var thumbnails = galleryThumbnailButtons(gallery);
    if (thumbnails.length < 2) return;
    var mediaItems = Array.from(gallery.querySelectorAll('.product__media-item'));
    var activeMedia = gallery.querySelector('.product__media-item.is-active');
    var currentIndex = activeMedia ? mediaItems.indexOf(activeMedia) : -1;
    if (currentIndex < 0) {
      currentIndex = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.getAttribute('aria-current') === 'true';
      });
    }
    if (currentIndex < 0) currentIndex = 0;
    var nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
    underlayGalleryThumbnails(gallery);
    warmGalleryImages(gallery, nextIndex, direction);
    thumbnails[nextIndex].click();
  }

  // 2026-10-11 (Clarity: a phone visitor tapped "next" 49 times in 35 s and left): the slider photos are loading="lazy", so a
  // photo only started to load when it scrolled into view and the big photo stayed white on quick taps. After the visitor
  // touches the gallery (the first view is unchanged):
  //  - load the photos ahead in the direction of travel (3 ahead, 1 behind) before they are needed,
  //  - put the small thumbnail photo (already on the page) under each big photo, so a blurry photo shows instead of white,
  //  - on phones, load the big photos at most 713 px wide (about half the bytes of 990 px; the store test session measured
  //    0.6 s per photo on Slow 4G).
  var MOCHI_GALLERY_PHONE = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;

  function galleryMediaItems(gallery) {
    return Array.from(gallery.querySelectorAll('.product__media-item'));
  }

  // The photo on screen. A swipe scrolls the slider without moving the theme's is-active class, so read the position.
  function visibleGalleryIndex(gallery) {
    var items = galleryMediaItems(gallery);
    var slider = gallery.querySelector('[id^="Slider-Gallery-"], .product__media-list');
    if (slider && slider.scrollWidth > slider.clientWidth + 1) {
      var left = slider.getBoundingClientRect().left, best = -1, bestDistance = Infinity;
      items.forEach(function (item, index) {
        var rect = item.getBoundingClientRect();
        if (!rect.width) return;
        var distance = Math.abs(rect.left - left);
        if (distance < bestDistance) { bestDistance = distance; best = index; }
      });
      if (best >= 0) return best;
    }
    var active = gallery.querySelector('.product__media-item.is-active');
    var activeIndex = active ? items.indexOf(active) : 0;
    return activeIndex < 0 ? 0 : activeIndex;
  }

  function warmGalleryImages(gallery, centerIndex, direction) {
    var items = galleryMediaItems(gallery);
    if (items.length < 2) return;
    if (!(centerIndex >= 0)) centerIndex = visibleGalleryIndex(gallery);
    var step = direction < 0 ? -1 : 1;
    var pick = function (offset) { return items[(centerIndex + offset * step + items.length) % items.length]; };
    // 1) tiny blurry photos first (a few KB each) for the shown photo and the next 3, so something shows at once
    [0, 1, 2, 3].forEach(function (offset) { underlayMediaItem(pick(offset)); });
    // 2) then the big photo of the shown one and the next one only (more would fight for a slow connection)
    [0, 1].forEach(function (offset) {
      var item = pick(offset);
      Array.prototype.forEach.call(item ? item.querySelectorAll('img[loading="lazy"]') : [], function (image) { image.loading = 'eager'; });
    });
  }

  var MOCHI_GALLERY_STYLE_DONE = false;
  function galleryWaitStyle() {
    if (MOCHI_GALLERY_STYLE_DONE) return;
    MOCHI_GALLERY_STYLE_DONE = true;
    var style = document.createElement('style');
    style.textContent = '.product__media.mochi-media-wait::after{content:"";position:absolute;left:50%;top:50%;width:2.8rem;height:2.8rem;'
      + 'margin:-1.4rem 0 0 -1.4rem;border:.3rem solid rgba(214,51,108,.2);border-top-color:rgba(214,51,108,.85);border-radius:50%;'
      + 'animation:mochi-media-spin .8s linear infinite;z-index:1;pointer-events:none}'
      + '@keyframes mochi-media-spin{to{transform:rotate(360deg)}}'
      + '@media (prefers-reduced-motion: reduce){.product__media.mochi-media-wait::after{animation-duration:2.4s}}';
    document.head.appendChild(style);
  }

  function tinyPhotoUrl(image) {
    var src = image && (image.getAttribute('src') || '');
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=120');
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }

  function underlayMediaItem(item) {
    var box = item && item.querySelector('.product__media');
    var big = box && box.querySelector('img');
    if (!box || !big || box.hasAttribute('data-mochi-underlay') || (big.complete && big.naturalWidth > 0)) return;
    var url = tinyPhotoUrl(big);
    if (!url) return;
    box.setAttribute('data-mochi-underlay', 'true');
    galleryWaitStyle();
    box.classList.add('mochi-media-wait');
    box.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
    box.style.backgroundSize = 'cover';
    box.style.backgroundPosition = 'center';
    box.style.backgroundRepeat = 'no-repeat';
    // once the big photo is there, take the blurry one and the spinner away (photos with transparent parts must not show it through)
    big.addEventListener('load', function () { box.style.backgroundImage = ''; box.classList.remove('mochi-media-wait'); }, { once: true });
  }

  function underlayGalleryThumbnails(gallery) {
    // kept for the arrow/thumbnail callers: underlay the shown photo
    var active = gallery.querySelector('.product__media-item.is-active');
    if (active) underlayMediaItem(active);
  }

  function capPhoneGalleryImages(gallery) {
    if (!MOCHI_GALLERY_PHONE) return;
    galleryMediaItems(gallery).forEach(function (item) {
      Array.prototype.forEach.call(item.querySelectorAll('img[loading="lazy"][srcset]'), function (image) {
        if (image.complete && image.naturalWidth > 0) return;
        var kept = image.getAttribute('srcset').split(',').map(function (part) { return part.trim(); }).filter(function (part) {
          var width = parseInt((part.split(/\s+/)[1] || '').replace('w', ''), 10);
          return width > 0 && width <= 713;
        });
        if (kept.length) image.setAttribute('srcset', kept.join(', '));
      });
    });
  }

  function enhanceGalleryWarmup(gallery) {
    if (gallery.hasAttribute('data-mochi-gallery-warm')) return;
    gallery.setAttribute('data-mochi-gallery-warm', 'true');
    capPhoneGalleryImages(gallery);
    var lastIndex = -1;
    var warm = function (direction) {
      var index = visibleGalleryIndex(gallery);
      var dir = typeof direction === 'number' ? direction : (lastIndex >= 0 && index < lastIndex ? -1 : 1);
      lastIndex = index;
      warmGalleryImages(gallery, index, dir);
    };
    ['pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
      gallery.addEventListener(type, function () { warm(); }, { passive: true });
    });
    var slider = gallery.querySelector('[id^="Slider-Gallery-"], .product__media-list');
    if (slider) {
      var pending = false;
      slider.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; warm(); });
      }, { passive: true });
    }
    galleryThumbnailButtons(gallery).forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () { underlayGalleryThumbnails(gallery); warmGalleryImages(gallery, index, 1); });
    });
    gallery._mochiWarm = warm;
  }

  function enhanceGalleryArrows(gallery) {
    if (gallery.hasAttribute('data-mochi-gallery-arrows-enhanced')) return;
    gallery.setAttribute('data-mochi-gallery-arrows-enhanced', 'true');
    if (galleryThumbnailButtons(gallery).length < 2) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer) return;
    var navigation = document.createElement('div');
    navigation.className = 'mochi-gallery-nav';
    navigation.setAttribute('aria-label', 'Product image navigation');
    var previous = createGalleryArrow('previous', 'Previous product image');
    var next = createGalleryArrow('next', 'Next product image');
    previous.addEventListener('click', function () { moveGallery(gallery, -1); });
    next.addEventListener('click', function () { moveGallery(gallery, 1); });
    navigation.append(previous, next);
    viewer.append(navigation);
  }

  function initGalleryArrows(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product:not(.featured-product).product--thumbnail_slider media-gallery').forEach(function (gallery) {
      enhanceGalleryArrows(gallery);
    });
    scope.querySelectorAll('.product:not(.featured-product) media-gallery').forEach(function (gallery) {
      enhanceGalleryWarmup(gallery);
    });
  }

  function fulfillmentTypeFor(productInfo, description, productTitle) {
    var explicit = String(productInfo.getAttribute('data-mochi-fulfillment-type') || '').trim().toLowerCase();
    if (explicit === 'preorder' || explicit === 'procured' || explicit === 'original_set') return explicit;
    var tags = String(productInfo.getAttribute('data-mochi-product-tags') || '').split('||').map(function (tag) {
      return tag.replace(/\s+/g, ' ').trim().toLowerCase();
    }).filter(Boolean);
    var text = normalizedText(description) + ' ' + String(productTitle || '');
    if (tags.some(function (tag) { return tag === 'original set' || /original sets?$/.test(tag); }) || /\bOriginal Sets?\b/i.test(text)) return 'original_set';
    if (tags.some(function (tag) { return tag === 'pre-order' || tag === 'preorder'; }) || /\bPre[\s-]?order\b/i.test(text)) return 'preorder';
    return 'procured';
  }

  function preorderMonthFor(productInfo) {
    var tags = String(productInfo.getAttribute('data-mochi-product-tags') || '').split('||');
    for (var index = 0; index < tags.length; index += 1) {
      var match = String(tags[index] || '').trim().match(/^MRJ_PREORDER_MONTH_(\d{4})-(0[1-9]|1[0-2])$/);
      if (match) return match[1] + '-' + match[2];
    }
    return '';
  }

  // 2026-10-06: a release month that has already passed (JST) is not a pre-order any more. About 37 released items still carry
  // mochiribbon.fulfillment_type=preorder and MRJ_PREORDER_MONTH_2018..2022 tags and showed "Expected warehouse arrival: December 2018".
  function isPastPreorderMonth(value) {
    var match = String(value || '').match(/^(\d{4})-(0[1-9]|1[0-2])$/);
    if (!match) return false;
    var jst = new Date(Date.now() + 9 * 60 * 60 * 1000);
    var current = jst.getUTCFullYear() * 12 + jst.getUTCMonth();
    return parseInt(match[1], 10) * 12 + (parseInt(match[2], 10) - 1) < current;
  }

  function hasPreorderTag(productInfo) {
    return String(productInfo.getAttribute('data-mochi-product-tags') || '').split('||').some(function (tag) {
      return /^pre-?order$/i.test(String(tag || '').trim());
    });
  }

  function formatPreorderMonth(value) {
    var match = String(value || '').match(/^(\d{4})-(0[1-9]|1[0-2])$/);
    if (!match) return '';
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[parseInt(match[2], 10) - 1] + ' ' + match[1];
  }

  function shippingMessage(type, preorderMonth) {
    if (type === 'preorder') {
      var arrivalText = formatPreorderMonth(preorderMonth);
      return 'This is a pre-order item. It ships on or after the release date' + (arrivalText ? (' (expected ' + arrivalText + ')') : '') + '.';
    }
    if (type === 'original_set') {
      return 'This set is assembled from individually sourced items and ships within 14 business days, once every item is ready.';
    }
    return 'Ships within 14 business days. Most in-stock orders leave Yokohama in 5–10 business days. Orders with several items ship together once everything is ready.';
  }

  function buildDutiesContent() {
    var body = document.createElement('div');
    body.className = 'body mochi-product-duty-list';
    [
      {
        label: '🇺🇸 US Customers — DDP:',
        text: 'Import duties and taxes are included in the product price. No surprise fees at delivery.'
      },
      {
        label: '🇪🇺 EU Customers in Belgium, Denmark, Estonia, Finland, France, Italy, Luxembourg, Malta, Netherlands, Slovakia, Spain, Sweden and Réunion — DDP:',
        text: 'Import duties and taxes are included in the product price. No surprise fees at delivery.'
      },
      {
        label: '🇬🇧 UK, Switzerland and Norway — DDU:',
        text: 'Import duties and taxes are not included in the product price and may be collected by local customs or the carrier on delivery.'
      },
      {
        label: '🌐 Other International Customers — DDU:',
        text: 'Import duties and taxes are not included in the product price and may be charged by local customs upon delivery.'
      }
    ].forEach(function (item) {
      var paragraph = document.createElement('p');
      var strong = document.createElement('strong');
      strong.textContent = item.label + ' ';
      paragraph.append(strong, document.createTextNode(item.text));
      body.append(paragraph);
    });
    return body;
  }

  function buildShippingContent(description, fulfillmentType, preorderMonth) {
    var fragment = document.createDocumentFragment();
    var shippingGroup = document.createElement('section');
    var shippingTitle = document.createElement('h3');
    var shippingBody = document.createElement('div');
    var shippingParagraph = document.createElement('p');
    shippingTitle.textContent = 'Shipping';
    shippingBody.className = 'body';
    shippingParagraph.textContent = shippingMessage(fulfillmentType, preorderMonth);
    shippingBody.append(shippingParagraph);
    shippingGroup.append(shippingTitle, shippingBody);
    fragment.append(shippingGroup);
    var dutiesGroup = document.createElement('section');
    var dutiesTitle = document.createElement('h3');
    dutiesTitle.textContent = 'Duties & Taxes';
    dutiesGroup.append(dutiesTitle, buildDutiesContent());
    fragment.append(dutiesGroup);
    var guaranteeGroup = document.createElement('section');
    var guaranteeTitle = document.createElement('h3');
    var guaranteeBody = document.createElement('div');
    var guaranteeParagraph = document.createElement('p');
    guaranteeTitle.textContent = 'Money-back guarantee';
    guaranteeBody.className = 'body';
    guaranteeParagraph.textContent = 'If your order arrives damaged or the carrier loses it, we refund you in full, including the shipping you paid. Damaged: contact us within 14 days of the delivery date shown in tracking, with photos of the item and the package. Lost: if tracking hasn\'t shown delivery by the estimated date, contact us within 60 days of shipment and we\'ll open an investigation with the carrier. We refund you once the carrier confirms the loss. Contact: mochiribbongodo@gmail.com or Instagram DM @mochiribbonllc.';
    guaranteeBody.append(guaranteeParagraph);
    guaranteeGroup.append(guaranteeTitle, guaranteeBody);
    fragment.append(guaranteeGroup);
    return fragment;
  }

  function enhanceDescription(description, index) {
    if (description.hasAttribute(enhancedAttribute)) return;
    var productInfo = description.closest('product-info');
    if (!productInfo || !description.closest('.product:not(.featured-product)')) return;

    var unique = (productInfo.id || 'MainProduct') + '-' + index;
    var component = document.createElement('section');
    component.className = 'mochi-product-details';
    component.setAttribute('aria-label', 'Product information');

    var tabList = document.createElement('div');
    tabList.className = 'mochi-product-tab-list';
    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', 'Product information sections');

    var detailsPanelId = 'MochiProductDetails-' + unique;
    var shippingPanelId = 'MochiProductShipping-' + unique;
    var detailsTab = createTab('MochiProductDetailsTab-' + unique, detailsPanelId, 'Product Details', true);
    var shippingTab = createTab('MochiProductShippingTab-' + unique, shippingPanelId, 'Shipping & Duties', false);
    var detailsPanel = createPanel(detailsPanelId, 'Product Details', true);
    var shippingPanel = createPanel(shippingPanelId, 'Shipping & Duties', false);
    detailsPanel.setAttribute('aria-labelledby', detailsTab.id);
    shippingPanel.setAttribute('aria-labelledby', shippingTab.id);

    var preferredDetails = description.querySelector('.mrj-desc .body');
    var detailsContent = cleanClone(preferredDetails || description);
    removeRedundantDetails(detailsContent);
    convertFactParagraphs(detailsContent);
    var productTitle = normalizedText(productInfo.querySelector('.product__title h1'));
    var manufacturer = String(productInfo.getAttribute('data-mochi-manufacturer') || '').replace(/\s+/g, ' ').trim();
    var fulfillmentType = fulfillmentTypeFor(productInfo, description, productTitle);
    var preorderMonth = preorderMonthFor(productInfo);
    if (preorderMonth && isPastPreorderMonth(preorderMonth)) {
      preorderMonth = '';
      if (fulfillmentType === 'preorder' && !hasPreorderTag(productInfo)) fulfillmentType = 'procured';
    }
    var structuredDetails = buildStructuredDetails(detailsContent, productTitle, manufacturer, fulfillmentType);
    detailsPanel.append(structuredDetails || buildGenericDetails(detailsContent, productTitle, Boolean(preferredDetails), manufacturer, fulfillmentType));
    shippingPanel.append(buildShippingContent(description, fulfillmentType, preorderMonth));

    tabList.append(detailsTab, shippingTab);
    // 2026-10-30 ゆうさく（本店のデザイン点検・見本C案）: the two tabs are not shown (Shipping & Duties repeats the five pixel-art rows below); the details panel stays open.
    tabList.style.display = 'none';
    component.append(tabList, detailsPanel, shippingPanel);

    var infoContainer = description.closest('.product__info-container');
    var confidence = infoContainer ? infoContainer.querySelector('.mochi-product-confidence') : null;
    if (confidence && confidence.parentNode === infoContainer) {
      infoContainer.insertBefore(component, confidence);
    } else {
      description.parentNode.insertBefore(component, description);
    }
    // 2026-10-30 ゆうさく「商品情報を左、ドット絵の説明を右に」: on desktop (two columns) the details card moves under the
    // photos in the left column; the five pixel-art rows stay in the right column. On phones the order is unchanged.
    var mediaWrapper = productInfo.querySelector('.product__media-wrapper');
    var anchor = document.createComment('mochi-product-details');
    component.parentNode.insertBefore(anchor, component);
    var wide = window.matchMedia('(min-width: 990px)');
    var placeDetails = function () {
      if (wide.matches && mediaWrapper) {
        if (component.parentNode !== mediaWrapper) { component.classList.add('mochi-product-details--under-media'); mediaWrapper.classList.add('mochi-media-has-details'); mediaWrapper.appendChild(component); }
      } else if (component.parentNode !== anchor.parentNode) {
        component.classList.remove('mochi-product-details--under-media'); if (mediaWrapper) mediaWrapper.classList.remove('mochi-media-has-details'); anchor.parentNode.insertBefore(component, anchor.nextSibling);
      }
    };
    placeDetails();
    if (wide.addEventListener) wide.addEventListener('change', placeDetails); else wide.addListener(placeDetails);

    description.classList.add('mochi-product-description-source');
    description.setAttribute('aria-hidden', 'true');
    description.setAttribute(enhancedAttribute, 'true');
    addTabBehavior(tabList, [detailsTab, shippingTab], [detailsPanel, shippingPanel]);
  }

  function positionGrowaveWishlist(scope) {
    scope.querySelectorAll('product-info .product__info-container').forEach(function (infoContainer) {
      var wishlist = infoContainer.querySelector('.shopify-block[id*="growave_loyalty_wishlist_block_product_fave_button"]');
      var addToCart = infoContainer.querySelector('.product-form__buttons button[name="add"]');
      var buttonGroup = addToCart ? addToCart.parentNode : null;
      var confidence = infoContainer.querySelector('.mochi-product-confidence');
      if (!wishlist) return;
      if (addToCart && buttonGroup && buttonGroup.classList.contains('product-form__buttons')) {
        wishlist.classList.add('mochi-growave-wishlist--purchase');
        bindGrowaveWishlistFeedback(wishlist);
        buttonGroup.insertBefore(wishlist, addToCart.nextSibling);
        return;
      }
      if (!confidence || wishlist.parentNode !== infoContainer || confidence.parentNode !== infoContainer) return;
      infoContainer.insertBefore(wishlist, confidence);
    });
  }

  function bindGrowaveWishlistFeedback(wishlist) {
    if (!wishlist || wishlist.getAttribute('data-mochi-wishlist-feedback-ready') === 'true') return;
    wishlist.setAttribute('data-mochi-wishlist-feedback-ready', 'true');
    wishlist.addEventListener('click', function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      var button = path.find(function (node) { return node && node.tagName === 'BUTTON'; });
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      var initialLabel = String(button.textContent || '').replace(/\s+/g, ' ').trim();
      var pendingLabel = /remove/i.test(initialLabel) ? 'Removing…' : 'Adding…';
      var placeholder = wishlist.querySelector('.gw-wl-add-to-wishlist-placeholder');
      var root = placeholder && placeholder.shadowRoot ? placeholder.shadowRoot : null;
      var observer = null;
      var timer = null;

      function clearPending() {
        if (observer) observer.disconnect();
        if (timer) window.clearTimeout(timer);
        observer = null;
        timer = null;
        wishlist.classList.remove('mochi-growave-wishlist--pending');
        wishlist.removeAttribute('data-mochi-wishlist-pending-label');
        wishlist.removeAttribute('aria-busy');
      }

      wishlist.setAttribute('data-mochi-wishlist-pending-label', pendingLabel);
      wishlist.setAttribute('aria-busy', 'true');
      wishlist.classList.add('mochi-growave-wishlist--pending');

      if (root && window.MutationObserver) {
        observer = new MutationObserver(function () {
          var currentLabel = String(root.textContent || '').replace(/\s+/g, ' ').trim();
          if (currentLabel && currentLabel !== initialLabel) clearPending();
        });
        observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true });
      }
      timer = window.setTimeout(clearPending, 2500);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initGalleryArrows(scope);
    positionGrowaveWishlist(scope);
    scope.querySelectorAll('product-info .product__description').forEach(function (description, index) {
      enhanceDescription(description, index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
